// The one place that names the "brotli" decompression format: it is newer than lib.dom's
// CompressionFormat union, and a browser that lacks it throws on construction, which is how
// manifest.ts's brotliSupported() learns to ask for the plain file instead.

/** A brotli decoder. Throws a TypeError where the browser has none. */
export function newBrotliDecoder(): DecompressionStream {
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion -- see the header: the format is valid at runtime, not yet in the lib's type.
  return new DecompressionStream("brotli" as CompressionFormat);
}
